import './Metric.scss'
import * as g from './Metric.generated'
import { useEffect, useMemo, useState } from 'react'
import { FieldInput } from '@/generated'
import { useHierarchicalFilterContext } from '@/contexts/HierarchicalFilterContext/HierarchicalFilterContext'
import { usePlatformOutletContext } from '../Platform/usePlatFormOutletContext'
import { usePageFilters } from '@/contexts/PageFilterContext/PageFilterContextProvider2'

export type MetricProps = g.MetricFragment & {
  tileFilterInputs?: FieldInput[]
}

function useMetric(metricId: string, tileFilterInputs?: FieldInput[], pageFilterInputs?: FieldInput[] | null) {
  const { appId, appKey, projectId } = usePlatformOutletContext()
  const { hierarchicalFilterInputs } = useHierarchicalFilterContext()
  const [metric, setMetric] = useState<g.MetricFragment | null | undefined>()

  const [getMetric, getMetricData] = g.useMetricLazyQuery()

  const filters = useMemo(() => {
    const _pageFilterInputs = pageFilterInputs ?? []
    const _tileFilterinputs = tileFilterInputs ?? []
    const _hierarchicalFilterinputs = hierarchicalFilterInputs ?? []
    return [..._tileFilterinputs, ..._pageFilterInputs, ..._hierarchicalFilterinputs]
  }, [tileFilterInputs, pageFilterInputs, hierarchicalFilterInputs])

  useEffect(() => {
    const fetchMetric = async () => {
      const fetchMetricData = await getMetric({
        fetchPolicy: 'network-only',
        variables: {
          appId: appKey,
          projectId,
          metricId,
          filters,
          extraInputs: [
            { name: 'appId', value: `${appId}` },
            { name: 'projectId', value: `${projectId}` },
          ],
        },
      })
      const _metric = fetchMetricData.data?.app?.metricById
      setMetric(_metric)
    }
    fetchMetric()
  }, [appId, appKey, filters, getMetric, metricId, projectId])

  return {
    metric,
    metricLoading: getMetricData.loading,
  }
}

export function Metric(props: MetricProps) {
  const { pageFilterInputs } = usePageFilters()
  const { metric, metricLoading } = useMetric(props.id, props.tileFilterInputs, pageFilterInputs)

  const classes = ['ux-metric'].filter(Boolean).join(' ')

  return (
    <div className={classes}>
      {metricLoading && 'Loading...'}
      {!metricLoading && (metric?.label ?? metric?.value)}
    </div>
  )
}
